var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo, useState } from 'react';
export var useRowSelection = function () {
    var _a = useState({}), selected = _a[0], setSelected = _a[1];
    var hasAnySelected = useMemo(function () { return Object.keys(selected).some(function (x) { return selected[x]; }); }, [selected]);
    var isSelected = useCallback(function (id) { return !!selected[id]; }, [selected]);
    return {
        isSelected: isSelected,
        toggleSelected: function (id) { return setSelected(function (x) {
            var _a;
            return (__assign(__assign({}, x), (_a = {}, _a[id] = !x[id], _a)));
        }); },
        resetSelected: function () { return setSelected({}); },
        selected: selected,
        getSelected: function () { return Object.keys(selected).filter(function (x) { return selected[x]; }); },
        hasAnySelected: hasAnySelected,
        setSelected: setSelected,
        selectAll: function (ids) {
            return setSelected(function (old) {
                var newValue = __assign({}, old);
                ids.forEach(function (id) {
                    newValue[id] = true;
                });
                return newValue;
            });
        },
    };
};
